<template>
    <span>
        <slot></slot>
        <span class="form-input-error" v-show="errors.has('email')">{{ errors.first('email') }}</span>
    </span>
</template>

<script>
    export default {
        name: 'InputValidationHandler',
        props: [],
        data: () => ({

        })
    }
</script>

<style lang="scss" scoped>

</style>
